$('.customer__list').slick({
    dots: true,
    infinite: true,
    speed: 300,
    
    adaptiveHeight: true
  
  });